export { default as ConnectWithUsMenuComponent } from './connect-with-us-menu.component';
export { default as FindASpaceMenuComponent } from './find-a-space-menu.component';
export { default as WhyHomiiLifeMenuComponent } from './why-homii-life-menu.component';
// export { default as MoreMenuComponent } from './more-menu.component';